/*
 *
 *  * Copyright (c) [hoarfroster-frontend] 2026. All Rights Reserved.
 *  *
 *  * Last Modified on Jun 21, 2026 by hoarfroster
 *
 */

import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import Footer from '@components/footer';
import { DashboardProvider } from '@utils/dashboard-widget-context';
import I18N from '@utils/i18n.base';
import { getUserInfo } from '@utils/user-info';
import { useTitle } from '@utils/title';
import { HomeDashboardGrid } from './home-dashboard-grid';

/**
 * Home page authentication gate plus dashboard composition.
 *
 * The heavy widget logic now lives in focused child modules so this file only
 * handles sign-in gating and the page-level shell.
 */
export default function HomePage() {
    useTitle(I18N.app.home);

    const navigate = useNavigate();
    const [isAuthenticated, setIsAuthenticated] = useState(false);

    useEffect(() => {
        const userInfo = getUserInfo();
        if (!userInfo.id || !userInfo.role) {
            void navigate('/auth/sign-in', { replace: true });
            return;
        }

        setIsAuthenticated(true);
    }, [navigate]);

    if (!isAuthenticated) {
        return null;
    }

    return (
        <DashboardProvider>
            <div className="bg-theme-bg flex h-full min-h-0 flex-1 flex-col overflow-hidden">
                <div className="min-h-0 w-full flex-1 overflow-hidden">
                    <HomeDashboardGrid />
                </div>

                <Footer className="border-theme-border-divider text-theme-text-muted mt-0 shrink-0 border-t" />
            </div>
        </DashboardProvider>
    );
}
